//const nf = "‌"; // nim fasele
//const tab = nf + " " + nf + " " + nf + " " + nf + " ";
//const enter = "/n" + nf;

const content = {
    english: {
        index: {

        },
        home: {

        },
        about: {

        },
        resume: {

        },
        portfolio: {

        },
        contact: {

        },
        theme: {

        }
    },

    persian: {
        header: {
            tab1: "خانه",
            tab2: "خدمات",
            tab2_1: "دپارتمان شبکه و امنیت",
            tab2_2: "دپارتمان سخت افزار و زیرساخت",
            tab2_3: "دپارتمان مشاوره و آموزش سازمانی",
            tab3: "درباره ما",
            tab4: "محصولات",
            tab5: "اخبار",
            tab6: "ارتباط با ما",
        },
        index: {
            banner: "شبکه عصر دانش آرا دروازه‌ای به سوی جهان سایبری",
            aboutLink: "درباره ما",
            aboutLinkSubtitle: "ما را بشناسید",
            contactLink: "ارتباط با ما",
            contactLinkSubtitle: "سلام",
            learnMore: "بیشتر",
            services: {
                1: {
                    title: "دپارتمان شبکه و امنیت",
                    subtitle: "دپارتمان شبکه و امنیت، متشکل از گروه های مشاوره، طراحی و پیاده سازی، پشتیبانی و نگهداری با بهره گیری از نیروها و عوامل متخصص و مجرب، یکی از فعال ترین بخش های مرکز فاوا در این مجموعه به شمار می‌آید.",
                    learnMore: "بیشتر",
                    link: "/network",
                    anime: "network1"
                },
                2: {
                    title: "دپارتمان سخت افزار و زیرساخت",
                    subtitle: "متخصصین دپارتمان سخت افزار با بررسی نیاز‌های سخت افزاری، بهترین و مناسب ترین راهکارها در راستای ارائه "
                        + "مشاوره، تعمیرات و تهیه و پشتیبانی تجهیزات سخت افزاری سازمان شما را ارائه خواهند داد."
                    ,
                    learnMore: "بیشتر",
                    link: "/hardware",
                    anime: "hardware1"
                },
                3: {
                    title: "دپارتمان مشاوره و آموزش سازمانی",
                    subtitle: "دپارتمان آموزش‌های سازمانی با شناخت صحیح از نیازهای آموزشی سازمان‌ها و ضرورت توانمند سازی و کارایی نیروی انسانی "
                        + "در بقا و رشد سازمان‌ها با توجه به رشد شتابنده رقبا و تغییرات نیاز‌های مشتریان، خدمات خود را با هدف توسعه فرصت‌های "
                        + "یادگیری بصورت فردی و گروهی ارائه می‌دهد."
                    ,
                    learnMore: "بیشتر",
                    link: "/learn",
                    anime: "education1"
                },
            },

        },
        services: {
            title: "خدمات",
            services: {
                1: {
                    title: "دپارتمان شبکه و امنیت",
                    subtitle: "دپارتمان شبکه و امنیت، متشکل از گروه های مشاوره، طراحی و پیاده سازی، پشتیبانی و نگهداری با بهره گیری از نیروها و عوامل متخصص و مجرب، یکی از فعال ترین بخش های مرکز فاوا در این مجموعه به شمار می‌آید.",
                    learnMore: "بیشتر",
                    link: "/network",
                    anime: "network1"
                },
                2: {
                    title: "دپارتمان سخت افزار و زیرساخت",
                    subtitle: "متخصصین دپارتمان سخت افزار با بررسی نیاز‌های سخت افزاری، بهترین و مناسب ترین راهکارها در راستای ارائه "
                        + "مشاوره، تعمیرات و تهیه و پشتیبانی تجهیزات سخت افزاری سازمان شما را ارائه خواهند داد."
                    , learnMore: "بیشتر",
                    link: "/hardware",
                    anime: "hardware1"
                },
                3: {
                    title: "دپارتمان مشاوره و آموزش سازمانی",
                    subtitle: "دپارتمان آموزش‌های سازمانی با شناخت صحیح از نیازهای آموزشی سازمان‌ها و ضرورت توانمند سازی و کارایی نیروی انسانی "
                        + "در بقا و رشد سازمان‌ها با توجه به رشد شتابنده رقبا و تغییرات نیاز‌های مشتریان، خدمات خود را با هدف توسعه فرصت‌های "
                        + "یادگیری بصورت فردی و گروهی ارائه می‌دهد."
                    ,
                    learnMore: "بیشتر",
                    link: "/learn",
                    anime: "education1"
                },
            },
            learnMore: "بیشتر",
        },
        network: {
            header: {
                title: "امنیت شبکه",
                subtitle: "از آنجا که امروزه تمامی ارتباطات و اطلاعات سازمان‌ها به صورت کامپیوتری درآمده است و انتقال اطلاعات و "
                    + "دسترسی به آن‌ها نیز مستلزم ایجاد و نگهداری شبکه‌هایی است که این امکان را فراهم می‌سازد، لذا بحث امنیت "
                    + "اطلاعات و ارتباطات شبکه‌های کامپیوتری، از اهمیت بالایی برخوردار است."
                    + "\n"
                    + "گروه امنیت شبکه در کنار سایر عوامل دپارتمان شبکه وظیفه طراحی و اجرای راهکارهای مختلف امنیتی در رده‌ها و "
                    + "لایه‌های مختلف شبکه، ارائه راهکارهای مختلف جهت پیاده سازی سناریوهای امنیتی و نیز ارتقاء دائم سیستم را "
                    + "انجام می‌دهد."
                    + "\n"
                    + "در این راستا این شرکت با بهره گیری از تجربه چندین ساله، امکان برقراری امنیت اطلاعات و ارتباطات را با اجرای "
                    + "دستورالعمل‌ها و نصب تجهیزات امنیتی همچون  UTM,Firewall را به شکل مطلوبی فراهم آورده است."
                ,
                anime: "network2"
            },
            tips: {
                tip1: "صرفه جویی در انرژی",
                anime1: "energySave1",
                tip2: "صرفه جویی در زمان",
                anime2: "timeManagement",
                tip3: "صرفه جویی در هزینه",
                anime3: "moneySave"
            },
            firstRow: {
                title: "مجازی سازی سرویس‌ها",
                subtitle: "رشد روز افزون نیاز سازمان‌ها و شرکت‌ها به ایجاد سرویس‌های جدید IT از یکسو و محدودیت خرید و نصب "
                    + "سرورهای فیزیکی ازسوی دیگر موجب استفاده گسترده از فناوری مجازی سازی شده است. مجازی سازی یک علم "
                    + "جدید نیست بلکه در اوایل دهه 80 میلادی شرکت IBM از تکنیک مجازی سازی برای اجرای چندین سیستم عامل "
                    + "بر روی Mainframe استفاده می‌کرد. در اواخر دهه 90 شرکت‌های دیگری همچون VMware و Citrix اقدام به "
                    + "ساخت و پیاده سازی تکنیک مجازی سازی بر روی سرور‌ها کردند و رفته رفته مدل‌های دیگری از مجازی سازی نیز "
                    + "توسط شرکت‌های فوق ایجاد و ارائه گردید."
                ,
                anime: "virtual1"
            },
            secondRow: {
                title: "خدمات دپارتمان شبکه",
                subtitle: "بخش آموزش سازمانی آمادگی آن را دارد تا نسبت به ارائه خدمات مشاوره آموزشی رایگان و تدوین نظام جامع آموزش کارکنان سازمان ها  و متعاقبا برنامه ریزی و اجرای آن اقدام نمایند. همچنین روند نیازسنجی و ارائه خدمات آموزشی بر اساس درخواست مشتری را حول محورهای ذیل ارائه می‌نماید :"
                    + "\n"
                    + "•       اجرای فرایند نیازسنجی آموزشی کارکنان بصورت علمی "
                    + "\n"
                    + "•      برنامه ریزی و اجرای آموزش ها با بهره مندی از سرفصل های استاندارد و منطبق بر دانش روز دنیا با قابلیت تطبیق برای مقتضیات و نیازمندی های سازمان."
                    + "\n"
                    + "•      تعدیل چشمگیر هزینه های آموزشی سازمان ها با حذف رویکرد شهریه محور"
                    + "\n"
                    + "•      انعطاف در زمانبندی و محل اجرای دوره های آموزشی"
                    + "\n"
                    + "•    حصول اطمینان از اثر بخشی آموزش های ارائه شده  از طریق تدوین و بکارگیری مکانیزم های سنجش مستمر"
                ,
                anime: "network3"
            },
            thirdRow: {
                title1: "پشتیبانی شبکه",
                subtitle1: "گروه پشتیبانی و نگهداری این مرکز وظیفه پشتیبانی فنی، اعم از ارتقاء سیستم یا برطرف کردن مشکلات پیش آمده "
                    + "در کمترین زمان ممکن را با ارائه راهکارهایی که در صورت بروز مشکلات مختلف سیستم را مجبور به تحمل کمترین "
                    + "زمان ممکن خارج از دسترس بودن نماید، برعهده دارد."
                ,
                anime: "network4",
                title2: "voip ",
                subtitle2: "Voice Over IP ، در اصل همان تکنولوژی انتقال صدا از طریق شبکه های مبتنی برIP می‌باشد. این بدان معناست "
                    + "که می‌توان سیستم های تلفنی را بر روی تمامی بسترهای IP مانند : اینترنت، اینترانت ( اینترنت ملی)، شبکه های "
                    + "نقطه به نقطه بیسیم یا سیمی انتقال داد."
                ,

            },
        },
        hardware: {
            header: {
                title: "سخت افزار",
                subtitle: "تنوع بازار سخت افزار و شركت‌های ارائه كننده این تجهیزات همراه با طیف مختلفی ازشركت‌های گارانتی دهنده این "
                    + "تجهیزات، همواره راه دشواری را در جهت انتخاب، فراروی مشتریان قرار می‌دهد. ما با مشاوره‌های تخصصی و رایگان "
                    + "با ارائه خدمات بروز و مناسب و ارتباط با واردكنندگان عمده محصولات سخت افزاری و همچنین واردات محصولات "
                    + "خاصی از کشورهای معتبر تولید کننده و دارای تکنولوژی، توانسته ایم سهم قـابل تـوجهی از این بـازار را در بخش‌های "
                    + "دولتی و خصوصی بدست آوریم و در این راستا هدف ما کسب اعتبار نام شرکت شبکه عصر دانش آرا با اعتماد "
                    + "سازی و خدمات پس از فروش مناسب است ."
                ,
                anime: "hardware2"
            },
            tips: {
                tip1: "بهبود عملکرد",
                anime1: "swissKnife",
                tip2: "دسترسی راحت تر",
                anime2: "access",
                tip3: "دسترسی بیشتر",
                anime3: "access2",
            },
            firstRow: {
                title: "زیرساخت شبکه",
                subtitle: "گروه مشاوره و طراحی شبکه در امر طراحی و ارائه راهکارهای مختلف بر اساس معتبرترین استانداردهای طراحی چه "
                    + "در رده LAN  و چه در راهکارهای WAN و ساختارهای یکپارچه نظیر VOIP فعالیت نموده و با در اختیار داشتن "
                    + "دانش فنی و تجربه عملی وظیفه بهینه سازی روند عملیات را دارا می‌باشد."
                ,
            },
            secondRow: {
                title: "خدمات دپارتمان زیرساخت شبکه و سخت افزار",
                subtitle: "پیاده سازی شبکه های LAN/WAN"
                    + "\n"
                    + "ارائه خدمات مشاوره و نظارت بر اجرای پروژه‌های زیرساخت شبکه"
                    + "\n"
                    + "تأمین زیرساخت‌های ارتباطی شبکه از طریق فیبرنوری، کابل مسی و تجهیزات بی سیم جهت توسعه خدمات شبکه"
                    + "\n"
                    + "ارائه خدمات مشاوره و پیاده سازی مرکز تلفن و مخابرات"
                    + "\n"
                    + "مشاوره، نصب و راه اندازی تجهیزات نظارتی و امنیت فیزیکی"
                    + "\n"
                    + "نصب و راه اندازی تجهیزات برق نرمال و اضطراری"
                ,
                anime: "hardware3"

            },
            thirdRow: {
                title: "طراحی و اجرای مراکز داده (دیتا سنتر)",
                subtitle: "مرکز داده (Data Center) به مجموعه‌‌ای از سرویس گرها، زیرساخت‌های ارتباطی/امنیتی و تجهیزات الکترونیکی گفته "
                    + "می‌شود که برای ارائه، نگهداری و پشتیبانی از سرویس‌های تحت شبکه (اینترنت/اینترانت/اکسترانت) به کار گرفته می‌شوند. "
                    + "سازمان‌ها، شرکت‌ها، و افراد می‌توانند با به کارگیری سرویس‌های ارائه شده از طرف مرکز داده وب‌گاه‌ها، اطلاعات و سرویس‌های "
                    + "مبتنی بر شبکه خود را بر روی اینترنت (اینترانت/اکسترانت) راه‌اندازی کنند. مرکز داده، بسته به نوع کاربردی که برای آن تعریف "
                    + "شده است، می‌تواند به عنوان یک مرکز پردازشی، مرکز ذخیره داده، مرکز جمع آوری داده و یا تمامی این موارد عمل کند. مراکز "
                    + "داده بسیار عظیم و متنوعی در سرتاسر شبکه جهانی اینترنت در حال سرویس دهی هستند که برخی از این مراکز استفاده تجاری "
                    + "محدود درون سازمانی دارند و برخی دیگر در اینترنت به صورت تجاری و یا عمومی قابل استفاده هستند."
                ,
                anime: "hardware4"
            },
            forthRow: {
                title: "نصب و راه اندازی تجهیزات نظارتی و امنیت فیزیکی CCTV",
                subtitle: "به طور کلی به تمام تجهیزاتی که وظیفه آن‌ها نمایش، ضبط و ویرایش تصاویر ویدیویی است CCTV گفته می‌شود. یعنی این "
                    + "تجهیزات شامل دوربین‌هایی است که تصاویر را ضبط و به دستگاه مرکزی جهت ذخیره و ویرایش منتقل می‌کنند. این تکنولوژی "
                    + "دارای دو نوع اصلی است:"
                    + "\n"
                    + "۱-	سیستم های مبتنی بر شبکه (IP) یا Network security systems "
                    + "\n"
                    + "۲-	 سیستم‌های آنالوگ"
                    + "\n"
                    + "این تجهیزات به بخشهای زیر تقسیم می‌شود:"
                    + "\n"
                    + "۱-	دوربین‌های مدار بسته  (Camera)"
                    + "\n"
                    + "۲-	 دستگاه‌های ضبط و نگهداری تصویر  (NVR,DVR)"
                    + "\n"
                    + "۳-	نرم افزار‌ها و سیستم عامل‌های پردازش تصاویر  (Softwares)"
                    + "\n"
                    + "سیستم‌های مبتنی بر شبکه نسل جدید تجهیزات حفاظت الکترونیک است و کارایی و کیفیت بسیار بیشتری نسبت به آنالوگ‌ها "
                    + "دارد. بخصوص در بخش پردازش تصاویر. برای مثال آن‌ها قادرند افرادی که از یک مسیر مشخص در محدوده دید آن دوربین‌ها "
                    + "عبور می‌کنند را بشمارند و آمار دقیق آن‌ها را گزارش کنند. یا پلاک خودروها را بخوانند و زمان و دفعات ورود و خروجشان و حتی نام "
                    + "مالک آن‌ها را ثبت کنند. یا چهره ها را تشخیص دهند و اگر کسی غیر از فرد مجاز که قبلا چهره‌ی او به سیستم معرفی شده وارد "
                    + "محل خاصی شود آژیر بکشند. از امکانات این سیستم ها که اساس آن‌ها بر پایه ضبط و ویرایش تصاویر است در سیستم های قوی و "
                    + "حرفه ای بسیار استفاده می‌کنند."
                ,
                anime: "camera2"
            },
            fifthRow: {
                title1: "نصب و راه اندازی تجهیزات برق نرمال و اضطراری  UPS",
                subtitle1: "این شرکت با بهره گیری از پرسنل متخصص در تمامی امور مربوط به خرید، نصب و راه اندازی تجهیزات برق نرمال، اضطراری، ضد"
                    + "انفجار، تابلوهای برق و سایر اقلام مورد نیاز در ساختمان‌ها، کارخانجات و مراکز داده خدمات مربوط به نصب، راه اندازی و نگهداری "
                    + "ارائه می‌دهد."
                    + "\n"
                    + "از UPS برای حفاظت از تجهیزات کامپیوتری در برابر مشکلات برق شهر و تامین برق لازم در مواقع قطع آن، استفاده کنید. هیچ "
                    + "روشی مانند استفاده از UPS یا یک منبع تغذیه بدون وقفه نمی‌تواند از تجهیزات شما در برابر مشکلات برق حفاظت کند. زمانی"
                    + "که شما یک سرور یا کامپیوتر گران قیمت دارید اهمیت وجود UPS بیشتر می‌شود. UPS برای حذف نوسانات ناخواسته برق "
                    + "ورودی و کنترل ولتاژ آن دارای مدارات خاصی است و برای حل مشکل قطع برق یا افت بیش از حد ولتاژ (افت ولتاژ برای بسیاری "
                    + "تجهیزات مضر است یا سبب از کار افتادن موقت آن‌ها می‌شود) از باتری استفاده می‌کند."
                ,
                title2: "فروش، نصب و راه اندازی تجهیزات تلفن آنالوگ و دیجیتال",
                subtitle2: "این شرکت آماده ارائه تجهیزات تلفنی با مارک پاناسونیک و آلکاتل که از معروفترین و خوشنام ترین برندهای "
                    + "سیستم های تلفنی در دنیاست، را دارد. همچنین تکنسین‌های این شرکت دارای گواهینامه‌های متعدد از شرکت پاناسونیک و "
                    + "آلکاتل برای نصب و راه اندازی انواع سیستم‌های مخابراتی مربوطه هستند."
                ,
                anime: "phone3"
            },
            sixthRow: {
                title: "فروش، نصب و رفع عیب تجهیزات فیبر نوری",
                subtitle: "فیبر نوری یکی از محیط‌های انتقال داده با سرعت بالا است. امروزه از فیبر نوری در موارد متفاوتی نظیر شبکه‌های تلفن شهری و "
                    + "بین شهری، شبکه‌های کامپیوتری و اینترنت استفاده بعمل می‌آید. فیبرنوری رشته‌هایی از تارهای شیشه‌ای بوده که هر یک از تارها "
                    + "دارای ضخامتی معادل تار موی انسان را داشته و از آنان برای انتقال اطلاعات در مسافت‌های طولانی استفاده می‌شود. "
                    + "\n"
                    + "با توجه به مزایای فراوان فیبر نوری، امروزه از این نوع كابل‌ها در موارد متفاوتی استفاده می‌شود. اكثر شبكه‌های كامپیوتری و یا "
                    + "مخابرات از راه دور در مقیاس وسیعی از فیبر نوری استفاده می‌نمایند."
                    + "\n"
                    + "این شرکت با پرسنل آموزش دیده و بهره‌وری از تجهیزات جوش فیبر نوری (fusion) با برند Corning آماده ارائه خدمات می‌باشد."
                ,
                anime: "fiber"
            },
            seventhRow: {
                title: "تعمیرات سخت افزار",
                subtitle: "بخش تعمیرات سخت افزار با به کارگیری از دانش تئوری و تجربه عملی کارشناسان خود همچنین با در اختیار داشتن تجهیزات به "
                    + "روز، خدماتی از قبیل تعمیرات کامپیوتر، لپتاپ، تجهیزات سخت افزاری شبکه همچنین ارتقای سخت افزاری آن‌ها و بازیابی اطلاعات "
                    + "را ارائه می‌دهد."
                ,
                anime: "hardware6"
            },
            eighthRow: {
                title: "سیستم‌های اعلام حریق هوشمند",
                subtitle: "این نوع سیستم‌ها از پیشرفته‌ترین سیستم‌های اعلام حریق در جهان بوده و تركیبی از تكنولوژی پیشرفته دیجیتال و تكنیك‌های "
                    + "نرم‌افزاری پردازش اطلاعات می‌باشند."
                    + "\n"
                    + "در سیستم اعلان حریق هر یك از تجهیزات اعم از دیتكتورها، شستی‌ها، بردهای ورودی و بردهای خروجی، آژیرها و... دارای كد در "
                    + "سیستم می‌باشند كه مركز كنترل قادر به شناسایی آن قطعه بفرد بوده و قابلیت دریافت اطلاعات را به طور جداگانه از هر یك از "
                    + "قطعات متصل به آن دارا می‌باشد و بر اساس تنظیمات از پیش تعیین شده توسط مدیر سیستم (از طریق نرم‌افزارهای مربوطه) "
                    + "اقدام به پردازش اطلاعات دریافتی، تصمیم‌گیری و نهایتا فعال نمودن خروجی‌های مربوطه می‌نماید."
                ,
                anime: "fire"
            },
        },
        learn: {
            header: {
                title: "آموزش",
                subtitle: "آمـوزش در مورد عـلوم كـامپیوتر یعنی بهره وری از سخت افزار، صرفه جویی در هزینه و زمان و... . شركت شبکه عصر دانش آرا  "
                    + "بر حسب وظیفه هـمواره همراه با ارائه كـلیه خدمات سخت افزاری، نرم افزاری و شبكه اقدام به برگزاری كلاس‌های آموزشی جهت "
                    + "ارتقاء سطح كاربری و آموزش نرم افزار و سخت افزار جدید می‌نماید كه در صورت تقاضای مشتری این كلاس‌های آموزشی كوتاه "
                    + "مدت رایگان به دوره‌های آموزشی بلند مدت وكم هزینه تبدیل خواهد شد. لازم به ذكر است كه حدود ۸۰% مشتریان شركت به "
                    + "دلیل كیفیت و انعـطاف پذیری شـركت در مورد شرایط مكـانی و زمـانی و قیمت‌های منـاسب دوره‌های آموزشی مد نظرشان از این "
                    + "گونه دوره‌ها استفاده می‌نمایند."
                ,
                anime: "teach4"
            },
            firstRow: {
                title: "بخش آموزش سازمانی ",
                subtitle: "بخش آموزش سازمانی آمادگی آن را دارد تا نسبت به ارائه خدمات مشاوره آموزشی رایگان و تدوین نظام جامع آموزش کارکنان "
                    + "سازمان‌ها و متعاقبا برنامه ریزی و اجرای آن اقدام نماید. همچنین روند نیازسنجی و ارائه خدمات آموزشی بر اساس درخواست "
                    + "مشتری را حول محورهای ذیل ارائه می‌نماید :"
                    + "\n"
                    + "۱-  اجرای فرایند نیازسنجی آموزشی کارکنان بصورت علمی"
                    + "\n"
                    + "۲-  برنامه ریزی و اجرای آموزش ها با بهره مندی از سرفصل های استاندارد و منطبق بر دانش روز دنیا با قابلیت تطبیق برای مقتضیات و نیازمندی‌های سازمان."
                    + "\n"
                    + "۳- تعدیل چشمگیر هزینه‌های آموزشی سازمان ها با حذف رویکرد شهریه محور"
                    + "\n"
                    + "۴- انعطاف در زمانبندی و محل اجرای دوره های آموزشی"
                    + "\n"
                    + "۵- حصول اطمینان از اثر بخشی آموزش‌های ارائه شده از طریق تدوین و بکارگیری مکانیزم‌های سنجش مستمر"
                ,
                anime: "teach2"
            },
            secondRow: {
                title: "خدمات مشاوره،گارانتی و پشتیبانی",
                subtitle: "١- مشاوره و ارائه راه حل‌ها و بهینه سازی شبکه ."
                    + "\n"
                    + "٢- آموزش مسئولین نگهداری شبکه از جهت نحوه کار شبکه، توپولوژی و نرم افزارهای مورد استفاده و همچنین رفع اشکالات نرم افزاری احتمالی."
                    + "\n"
                    + "٣- گارانتی کلیه تجهیزات، زیرساختها و خدمات شبکه از جهت سخت افزاری و نرم افزاری"
                    + "\n"
                    + "٤- پشتیبانی و رفع مشکلات احتمالی در کمتر از 24 ساعت"
                ,
                anime: "teach3",
            },
            thirdRow: {
                title: "پشتیبانی و نگهداری",
                subtitle: "پس از مراحل خرید، نصب و راه اندازی یا پیاده سازی نرم افزار یا سخت افزار نگهداری و پشتیبانی یعنی آنكه ما از "
                    + "سرمایه گذاری كه در جهت اهداف انجام داده‌ایم حمایت كنیم و در غیر اینصورت پس از زمانی كوتاه باید شاهد "
                    + "عواقب وخیمی در سیستم بود ."
                    + "\n"
                    + "طراحی چك لیست كنترل"
                    + "\n"
                    + "آموزش‌های ابتدایی"
                    + "\n"
                    + "نصب آنتی ویروس‌های به روز"
                    + "\n"
                    + "تجهیز سرویس پک‌های سیستم عامل"
                    + "\n"
                    + "بکاپ گیری دوره‌ای"
                    + "\n"
                    + "طراحی و تجهیز سیستم‌های اضطراری"
                    + "\n"
                    + "نگهداری و پشتیبانی سیستم‌های موجود (سخت افزار و نرم افزاری)"
                    + "\n"
                    + "بخشی از فعالیت‌های ما در جهت نگهداری از سرمایه‌های شماست بنابراین ما جهت حصول اطمینان شما پرداخت "
                    + "مراحل نهایی حق الزحمه مهندسین و مشاورین شركت را پس از تأیید و اعلام رضایت شما كارفرمای گرامی از "
                    + "مطالعات، سیستمها، خدمات، نرم افزارهای ارائه شده، آموزش ها و... قرارداده ایم."
                ,
                anime: "database"
            },
            forthRow: {
                title: "مشاوره سخت افزار",
                subtitle: "بسیاری از مشکلات کاربران سیستم های کامپیوتری در سازمان های دولتی و یا شرکت های خصوصی نامناسب "
                    + "بودن و عدم بررسی نیازهای سخت افزاری جهت انجام امور مورد نظر آن‌ها می‌باشد. متأسفانه در بسیاری از موارد "
                    + "دیده‌شده که در انتخاب قطعات کامپیوتر دقت و حساسیت لازم صورت نگرفته و این امر باعث بروز مشکلاتی از "
                    + "جمله کندی سیستم برای کاربران آن‌ها می‌شود. کارشناسان سخت افزار در این مجموعه با تحلیل و بررسی دقیق "
                    + "نیازهای مشتری و با در نظر گرفتن المانهای مختلف مانند نرم افزارهای مورد استفاده کاربر و بسیاری موارد "
                    + "تخصصی دیگر، امکان ارائه مشاوره و تأمین سخت افزار مورد نیاز آن‌ها را فراهم می‌کنند."
            },
            fifthRow: {
                title: "مشاوره و امكان سنجی ",
                subtitle: "با ورود به هزاره سوم و جدی تر شدن مفهوم جهانی شدن در اقتصاد، پیچیدگی رقابت در فضای كسب و كار، "
            }

        },
        estimate: {
            header: {
                title: "دپارتمان آموزش سازمانی",
                subtitle: "دپارتمان آموزش های سازمانی با شناخت صحیح از نیازهای آموزشی سازمان ها و  ضرورت  توانمند سازی  و کارائی نیروی انسانی در بقاء و رشد سازمان ها با توجه به رشد شتابنده رقبا و تغییرات نیاز های مشتریان، خدمات خود را با هدف توسعه فرصت های یادگیری بصورت فردی و گروهی ارائه می‌دهد.",
                anime: "virtual"
            },
            tips: {
                tip1: "بهبود عملکرد",
                anime1: "swissKnife",
                tip2: "دسترسی راحت تر",
                anime2: "access",
                tip3: "دسترسی بیشتر",
                anime3: "access2",
            },
            firstRow: {
                title: "",
                subtitle: "بخش آموزش سازمانی آمادگی آن را دارد تا نسبت به ارائه خدمات مشاوره آموزشی رایگان و تدوین نظام جامع آموزش کارکنان سازمان ها  و متعاقبا برنامه ریزی و اجرای آن اقدام نمایند. همچنین روند نیازسنجی و ارائه خدمات آموزشی بر اساس درخواست مشتری را حول محورهای ذیل ارائه می‌نماید :"
                    + "\n"
                    + "1)       اجرای فرایند نیازسنجی آموزشی کارکنان بصورت علمی "
                    + "\n"
                    + "2)      برنامه ریزی و اجرای آموزش ها با بهره مندی از سرفصل های استاندارد و منطبق بر دانش روز دنیا با قابلیت تطبیق برای مقتضیات و نیازمندی‌های سازمان."
                    + "\n"
                    + "3)      تعدیل چشمگیر هزینه‌های آموزشی سازمان ها با حذف رویکرد شهریه محور"
                    + "\n"
                    + "4)      انعطاف در زمانبندی و محل اجرای دوره‌های آموزشی"
                    + "\n"
                    + "5)    حصول اطمینان از اثر بخشی آموزش های ارائه شده  از طریق تدوین و بکارگیری مکانیزم‌های سنجش مستمر"
                ,
                anime: "fire"
            }
        },
        about: {
            title: "درباره ما",
            subtitle: "هر چه زمان می‌گذرد حجم اطلاعاتی که انسان با آن‌ها سروکار دارد بیشتر و بیشتر می‌گردد. مدت‌هاست که جمع آوری و پردازش "
                + "اطلاعات توسط کامپیوتر صورت می‌گیرد. ازطرف دیگر نیاز به ارتباطات سریع ملموس است، شرایطی را مجسم کنید که انتقال و "
                + "هدایت اطلاعات ممکن نباشد، شبکه اینترنت وجود نداشته باشد، اصلاً شبکه ای وجود نداشته باشد و تمام خدمات مدرن امروزی "
                + "همانند پست الکترونیکی، خرید و فروش الکترونیکی کلاً از صحنه اجتماع امروز حذف شود چه پیش خواهد آمد، چند سال عقب "
                + "خواهیم رفت، آیا اهمیت شبکه ها کمتر از اختراع برق وماشین بخار و... است ؟ مسلما نه"
                + "\n"
                + "امروز کامپیوتر به کمک ارتباطات آمده وسرعت توزیع اطلاعات را چندین برابرکرده است. شبکه‌‌های کامپیوتری امروزه فصل نوینی "
                + 'در انفورماتیک است و میرود که مفهوم "دهکده جهانی" را تحقق بخشد. هر شخصی می‌تواند در اقصی نقاط دنیا، تنها با فشردن '
                + "کلیدهایی از صفحه کلید کامپیوتر، در چند ثانیه بعد از تازه ترین اطلاعات و موضوعات مورد نظر خود با خبر شود."
                + "\n"
                + "شرکت شبکه عصر دانش آرا افتخار دارد درجهت بهره وری بهینه از شبکه‌های کامپیوتری و برخورداری از فاکتورهای امروزی، "
                + "روزانه با چندین نفر از کارکنان خود درکشورهای (آمریکا، کانادا، مجارستان، هند و چند شهر ایران) در راستای به روز رسانی و "
                + "ارتقای دانش انفورماتیک مجموعه به منظور بهبود ارائه خدمات به مشتریان محترم خود در ارتباط باشد."
            ,
            anime: "history",

            firstRow: {
                title: "تاریخچه",
                subtitle: 'شرکت شبکه عصر دانش آرا افتخار دارد که درجهت بهره‌وری بهینه از شبکه‌های کامپیوتری و برخورداری از فاکتورهای امروزی هرروزه با چندین نفر از کارکنان خود درکشورهای امریکا ،کانادا ،مجارستان ،هند وچند شهرایران ارتباط دارد. امروزکامپیوتر به کمک ارتباطات آمده وسرعت توزیع اطلاعات را چندین برابرکرده است. شبکه های کامپیوتری امروزه فصل نوینی در انفورماتیک است و میرود که مفهوم "دهکده جهانی" را تحقق بخشد. هرشخصی میتواند دراقصی نقاط دنیا ،تنها با فشردن کلیدهایی از صفحه کلید کامپیوتر، در چند ثانیه بعد از تازه ترین اطلاعات و موضوعات مورد نظر خود با خبر شود.',
                anime: "history"
            },

            title2: "گروه ما",
            member1: "احسان صمیمی",
            position1: "مدیر عامل",
            member2: "فراز مرادی",
            position2: "مدیر بخش یک",
            member3: "امیر رویین نژاد",
            position3: "مدیر بخش دو",
            member4: "اسم عربی",
            position4: "مدیر بخش سه",

            secondRow: {
                title1: "اهداف شرکت",
                subtitle1: "\n"
                    + "رفع بحران‌های كمبود سیستم ها"
                    + "\n"
                    + "ارتقاء كمی و كیفی محصولات موجود"
                    + "\n"
                    + "بهبود و توسعه ظرفیت‌های مدیریت علمی ، فنی و تحلیلی"
                    + "\n"
                    + "توسعه همه جانبه مشاوران، مهندسان و مدیران"
                    + "\n"
                    + "تشكیل تیم‌های تخصصی"
                    + "\n"
                    + "تلاش گروهی"
                    + "\n"
                    + "بازدهی ثمربخش"
                    + "\n"
                    + "توان رقابت در بازار"
                    + "\n"
                    + "حضور توانمند در پروژه های داخلی و خارجی"
                    + "\n"
                    + "استفاده از آخرین فناوری‌ها"
                    + "\n"
                    + "بالفعل كردن اندیشه‌های علمی"
                    + "\n"
                    + "تحقیقات تخصصی"
                ,

                title2: "اصول و ارزشهای شركت",
                subtitle2: "\n"
                    + "صداقت در گفتار، پندار، كردار"
                    + "\n"
                    + "تمركز بر نقاط قوت و از بین بردن نقاط ضعف"
                    + "\n"
                    + "پایبندی به تعهدات"
                    + "\n"
                    + "بهبود مستمر"
                    + "\n"
                    + "پشتیبانی‌های به موقع"
                    + "\n"
                    + "توانمند سازی اعضاء"
                    + "\n"
                    + "اصلاح مدیریت‌ها و توسعه مدیریت‌های كارآفرین"
                ,

            },

        },
        products: {
            header: "محصولات",
            title1: "توضیحات",
            subtitle1: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title2: "محصول1",
            subtitle2: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title3: "محصول2",
            subtitle3: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title4: "محصول3",
            subtitle4: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title5: "محصول4",
            subtitle5: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title6: "محصول5",
            subtitle6: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title7: "محصول6",
            subtitle7: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title8: "محصول7",
            subtitle8: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title9: "محصول8",
            subtitle9: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title10: "محصول9",
            subtitle10: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
            title11: "محصول10",
            subtitle11: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
        },
        contact: {
            header: "ارتباط با ما",
            subHeader: "منتظر تماس شما هستیم",
            address: "تهران، خیابان مفتح جنوبی، بین خیابان طالقانی و سمیه، کوچه معیر۱، پلاک۴۰، واحدA۱",
            phone1: "(۰۲۱) ۸۸۳۴۲۵۶۷",
            phone2: "(۰۲۱) ۸۸۳۴۲۵۶۸",
            phone3: "(۰۲۱) ۸۸۳۴۲۵۶۹",
            email: "info@sada-co.com",
        },
        partnerCompanies: {
            partnerCompanies: "شرکت های همکار",
            partnerCompanie1: "شرکت 1",
            partnerCompanie2: "شرکت 2",
            partnerCompanie3: "شرکت 3",
            contactLink: "ارتباط با ما",
            learnMore: "بیشتر",
        },
        footer: {
            col1_1: "خانه",
            col2_1: "خدمات",
            col2_2: "دپارتمان شبکه و امنیت",
            col2_3: "دپارتمان سخت افزار و زیرساخت",
            col2_4: "دپارتمان مشاوره و آموزش سازمانی",
            col3_1: "درباره ما",
            col3_2: "ارتباط با ما",
            copyright: "Copyright © SADA-CO. All rights reserved. Website Designed by ",
            designer: "fmcv.ir ",
            year: "2021",
        },
    }
}

export default content;
